export * as entries from './entries'
export * from './stakeholder-perceived-attitude'
